module.exports = __webpack_public_path__ + "static/media/R_AngelsOfAether_Promo_203.4bb957ad.jpg";